import React, { useEffect, useState } from "react";
import Sidemenu from "../../components/sidemenu";
import Header from "../../components/header";
import styles from "./styles/practice.module.scss";
import * as Styled from "./styled";
import { Button, DatePicker, Dropdown, Pagination, Select } from "antd";
import deleteIcon from "../../images/delete.svg";
import { functionService } from "../../lib/functions";
import { useNavigate } from "react-router-dom";
const arr = [
   {
      id: 1,
      title: "test",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 2,
      title: "test1",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 3,
      title: "test2",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 4,
      title: "test3",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 5,
      title: "test3",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 6,
      title: "test3",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 7,
      title: "test3",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 8,
      title: "test3",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 9,
      title: "test3",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 10,
      title: "test3",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
   {
      id: 11,
      title: "test3",
      skill: "react",
      topic: "test",
      type: "mcq",
   },
];

const PracticeModule = () => {
   const [selectedQuestions, setSelectedQuestions] = useState([]);
   const [listState, setListState] = useState(10);
   const [startDate, setStartDate] = useState();
   const [endDate, setEndDate] = useState();
   const [edit, setEdit] = useState(false);
   const [access, setAccess] = useState(null);
   const [questData, setQuesData] = useState([]);
   let heading = "Test";
   const reg = new RegExp("^[0-9]+$");
   const [leveStatus, steLevelStatus] = useState(1);
   const [editTestDetails, setEditTestDetails] = useState();
   const [error, setError] = useState(null);
   const [emails, setEmails] = useState([]);
   const [validEmailCheck, setValidEmailCheck] = useState(true);
   const [difficulty_level, setDifficulty_level] =
      useState("Select difficulty");
   const [levelData, setLevelData] = useState({
      title: null,
      description: null,
      levelNo: null,
      totalQuestions: null,
      difficulty_level: null,
      beans: null,
      isCertificateRequired: true,
      MaxQuestionToPass: null,
      badge: null,
   });
   const navigate = useNavigate();

   useEffect(() => {
      if (window && window.location.pathname) {
         if (window.location.pathname.split("/")[2] === "edit") {
            setEdit(true);
            getEditTestDetails();
         }
      }
   }, []);

   useEffect(() => {
      if (leveStatus === 2) {
         getQuestions();
      }
   }, [leveStatus]);
   useEffect(() => { }, [levelData]);

   const handleDate = (date, type) => {
      if (type === "start") {
         setStartDate(date);
      } else {
         setEndDate(date);
      }
   };

   const getEditTestDetails = async () => {
      const response = await functionService.get(
         `practice/get-level/${window.location.pathname.split("/")[3]}`
      );
      setLevelData(...response?.response?.data?.meta?.data);
      setSelectedQuestions(response?.response?.data?.meta?.data[1]);
      setAccess(response?.response?.data?.meta?.data[0]?.status);
      if (response?.response?.data?.meta?.data[0]?.status === "PRIVATE") {
         setEmails(response?.response?.data?.meta?.data[0]?.emails);
      }
   };
   const getQuestions = async () => {
      const response = await functionService.get("practice/practice-questions");
      setQuesData(response?.response?.data?.meta?.data);
      // debugger;
   };

   const handleSubmit = () => {
      if (levelData.title === "" || levelData.title === null) {
         setError("Please enter test title");
      } else if (levelData.levelNo === "" || levelData.levelNo === null) {
         setError("Please enter level number");
      } else if (
         levelData.totalQuestions === "" ||
         levelData.totalQuestions === null
      ) {
         setError("Please enter total question");
      } else if (!reg.test(levelData.levelNo)) {
         setError("Please enter valid level number");
      } else if (!reg.test(levelData.totalQuestions)) {
         setError("Please enter valid total question");
      } else if (levelData.beans === "" || levelData.beans === null) {
         setError("Please enter coffeee beans");
      } else if (!reg.test(levelData.beans)) {
         setError("Please enter valid coffeee beans");
      } else if (levelData.badge === "" || levelData.badge === null) {
         setError("Please select the winning badge");
      } else if (
         levelData.MaxQuestionToPass === "" ||
         levelData.MaxQuestionToPass === null
      ) {
         setError("Please enter number of questions to pass level");
      } else if (!reg.test(levelData.MaxQuestionToPass)) {
         setError("Please enter valid number of questions to pass level");
      } else {
         setError(null);
         steLevelStatus(2);
      }
   };
   let pageMode = "";

   const badge = [
      {
         value: "YELLOW",
         label: "Yellow",
      },
      {
         value: "ORANGE",
         label: "Orange",
      },
      {
         value: "GREEN",
         label: "Green",
      },
      {
         value: "BLUE",
         label: "Blue",
      },
      {
         value: "PURPLE",
         label: "Purple",
      },
      {
         value: "BROWN",
         label: "Brown",
      },
      {
         value: "BLACK",
         label: "Black",
      }, {
         value: "RED",
         label: "Red",
      }, {
         value: "WHITE",
         label: "White",
      }, {
         value: "VIOLET",
         label: "Violet",
      },
   ];
   const addLevels = [
      { name: "Test Details", status: leveStatus > 1 ? 3 : 2 },
      {
         name: "Add Questions",
         status: leveStatus === 1 ? 1 : leveStatus === 2 ? 2 : 3,
      },
      { name: "Publish", status: 1 },
   ];

   const publishLevel = async () => {
      var questionsArr = [];
      for (let i = 0; i < selectedQuestions.length; i++) {
         questionsArr.push(selectedQuestions[i].id);
      }
      for (let i = 0; i < emails.length; i++) {
         if (emails[i].substr(0, 1) === "\n") {
            emails[i] = emails[i].substr(1, emails[i].length);
         }
         if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emails[i])) {
            continue;
         } else {
            setValidEmailCheck(false);
            return;
         }
      }
      if (edit) {
         const response = await functionService.post("practice/edit-level", {
            ...levelData,
            questionsArr: questionsArr,
            status: access,
            emails: emails,
            start_date: startDate ? startDate.format() : null,
            end_date: endDate ? endDate.format() : null,
            practice_level_id: window.location.pathname.split("/")[3],
         });
         if (response.status) {
            navigate("/practice-assessment-test", { replace: true });
         }
      } else {
         const response = await functionService.post("practice/add-level", {
            ...levelData,
            questionsArr: questionsArr,
            status: access,
            emails: null,
            start_date: startDate ? startDate.format() : null,
            end_date: endDate ? endDate.format() : null,
         });
         if (response.status) {
            navigate("/practice-assessment-test", { replace: true });
         }
      }
   };

   return (
      <div className={styles.container}>
         <Sidemenu className={styles.side} />
         <div className={styles.side_container}>
            <Header />

            <p className={styles.heading}>
               {edit ? "Edit Level" : "New Level"}
            </p>
            {leveStatus === 1 && (
               <div className={styles.side_data}>
                  <div className={styles.side_inside_container}>
                     <Styled.LevelWrapDiv>
                        {addLevels.map((level, levelIndex) => {
                           let numStyle = {};
                           let textStyle = {};
                           if (level.status === 2) {
                              numStyle = {
                                 color: "#1B49EA",
                                 backgroundColor: "#EDF0FD",
                                 fontWeight: "bold",
                              };
                              textStyle = { fontWeight: "bold" };
                           } else if (level.status === 3) {
                              numStyle = {
                                 color: "#21C17A",
                                 backgroundColor: "#cbf5e3",
                                 fontWeight: "bold",
                              };
                              textStyle = { color: "#21C17A" };
                           }
                           return (
                              <Styled.LevelDiv key={`testing_${levelIndex}`}>
                                 <Styled.LevelNumDiv style={numStyle}>
                                    {levelIndex + 1}
                                 </Styled.LevelNumDiv>
                                 <div style={textStyle}>{level.name}</div>
                              </Styled.LevelDiv>
                           );
                        })}
                        <Styled.LevelActiveBarDiv style={{ width: "0" }} />
                        <Styled.LevelBarDiv practice={true} />
                     </Styled.LevelWrapDiv>

                     <div>
                        <p>Test title</p>
                        <input
                           placeholder="Enter test title"
                           onChange={(e) =>
                              setLevelData((prev) => {
                                 return { ...prev, title: e.target.value };
                              })
                           }
                           value={levelData.title}
                        />
                     </div>
                     <div>
                        <p>Description</p>
                        <input
                           placeholder="Enter Description"
                           onChange={(e) =>
                              setLevelData((prev) => {
                                 return {
                                    ...prev,
                                    description: e.target.value,
                                 };
                              })
                           }
                           value={levelData.description}
                        />
                     </div>
                     <div>
                        <p>Level number</p>
                        <input
                           placeholder="Enter Level number"
                           onChange={(e) =>
                              setLevelData((prev) => {
                                 return { ...prev, levelNo: e.target.value };
                              })
                           }
                           value={levelData.levelNo}
                        />
                     </div>
                     <div>
                        <p>Total questions</p>
                        <input
                           placeholder="Enter questions"
                           onChange={(e) =>
                              setLevelData((prev) => {
                                 return {
                                    ...prev,
                                    totalQuestions: e.target.value,
                                 };
                              })
                           }
                           value={levelData.totalQuestions}
                        />
                     </div>

                     <div>
                        <p>Coffeee Beans</p>
                        <input
                           placeholder="Enter coffeee beans"
                           onChange={(e) =>
                              setLevelData((prev) => {
                                 return {
                                    ...prev,
                                    beans: e.target.value,
                                 };
                              })
                           }
                           value={levelData.beans}
                        />
                     </div>

                     <div className={styles.dropdown}>
                        <p>Badges</p>
                        <Select
                           labelInValue
                           placeholder={"Select winning badge"}
                           style={{ width: "60%" }}
                           onChange={(e) => {
                              setLevelData((prev) => {
                                 return { ...prev, badge: e.key };
                              });
                           }}
                           options={badge}
                           value={levelData.badge}
                        />
                     </div>
                     <div className={styles.checkbox}>
                        <input
                           style={{ width: "fit-content" }}
                           type="checkbox"
                           id="isCertificateRequired"
                           name="isCertificateRequired"
                           checked={levelData.isCertificateRequired}
                           onChange={(e) => {
                              setLevelData((prev) => {
                                 return {
                                    ...prev,
                                    isCertificateRequired: e.target.checked,
                                 };
                              });
                           }}
                        />
                        <label for="isCertificateRequired">
                           {" "}
                           Give certificate
                        </label>
                     </div>
                     <div>
                        <p>Questions to pass level</p>
                        <input
                           placeholder="Enter questions to pass level"
                           onChange={(e) =>
                              setLevelData((prev) => {
                                 return {
                                    ...prev,
                                    MaxQuestionToPass: e.target.value,
                                 };
                              })
                           }
                           value={levelData.MaxQuestionToPass}
                        />
                     </div>

                     {error && (
                        <p
                           style={{
                              color: "red",
                              fontWeight: "700",
                              margin: "25px 0",
                           }}
                        >
                           {error}
                        </p>
                     )}
                     <div className={styles.btn_container}>
                        <input
                           type={"submit"}
                           className={styles.btn}
                           value={"Submit"}
                           onClick={() => {
                              handleSubmit();
                           }}
                        />
                     </div>
                  </div>

                  {/* <div className={styles.side_inside_container}></div> */}
               </div>
            )}
            {leveStatus === 2 && (
               <div className={styles.side_data}>
                  <Styled.LevelWrapDiv>
                     {addLevels.map((level, levelIndex) => {
                        let numStyle = {};
                        let textStyle = {};
                        if (level.status === 2) {
                           numStyle = {
                              color: "#1B49EA",
                              backgroundColor: "#EDF0FD",
                              fontWeight: "bold",
                           };
                           textStyle = { fontWeight: "bold" };
                        } else if (level.status === 3) {
                           numStyle = {
                              color: "#21C17A",
                              backgroundColor: "#cbf5e3",
                              fontWeight: "bold",
                           };
                           textStyle = { color: "#21C17A" };
                        }
                        return (
                           <Styled.LevelDiv key={`testing_${levelIndex}`}>
                              <Styled.LevelNumDiv style={numStyle}>
                                 {levelIndex + 1}
                              </Styled.LevelNumDiv>
                              <div style={textStyle}>{level.name}</div>
                           </Styled.LevelDiv>
                        );
                     })}
                     <Styled.LevelActiveBarDiv style={{ width: "145px" }} />
                     <Styled.LevelBarDiv practice={true} />
                  </Styled.LevelWrapDiv>

                  {/* <div className={styles.question_count_container}>
                  <div className={styles.question_count}>
                     Question in Test : <strong>0/3</strong>
                  </div>
                  <div className={styles.question_count}>
                     Total Marks : <strong>0/3</strong>
                  </div>
               </div> */}
                  <div className={styles.left_right_container}>
                     <div className={styles.left_container}>
                        {selectedQuestions && selectedQuestions.length > 0 ? (
                           selectedQuestions.map((item, index) => {
                              return (
                                 <div>
                                    <p>{item.title}</p>
                                    <button>
                                       <img
                                          src={deleteIcon}
                                          alt=""
                                          onClick={() => {
                                             setSelectedQuestions(
                                                selectedQuestions.filter(
                                                   (item) => {
                                                      return (
                                                         item.id !==
                                                         selectedQuestions[
                                                            index
                                                         ].id
                                                      );
                                                   }
                                                )
                                             );
                                          }}
                                       />
                                    </button>
                                    {/* <div>Marks 2</div> */}
                                 </div>
                              );
                           })
                        ) : (
                           <p>
                              Please Add
                              <br /> Questions to Test
                           </p>
                        )}
                     </div>
                     <div className={styles.right_container}>
                        {questData && questData.length > 0 && (
                           <table>
                              <tr>
                                 <td style={{ width: "30%" }}>
                                    Question Title
                                 </td>
                                 <td style={{ width: "30%" }}>Skills</td>
                                 <td style={{ width: "15%" }}>Topic</td>
                                 <td style={{ width: "15%" }}>Type</td>
                                 <td style={{ width: "10%" }}>Action</td>
                              </tr>
                              {questData
                                 .slice(listState - 10, listState)
                                 .map((i, index) => {
                                    return (
                                       <tr>
                                          <td style={{ width: "30%" }}>
                                             {i.title}
                                          </td>
                                          <td style={{ width: "30%" }}>
                                             {i.skill}
                                          </td>
                                          <td style={{ width: "15%" }}>
                                             {i.topic_name}
                                          </td>
                                          <td style={{ width: "15%" }}>
                                             {i.difficulty_level}
                                          </td>
                                          <td style={{ width: "10%" }}>
                                             {selectedQuestions.find((item) => {
                                                return item.id === i.id;
                                             }) ? (
                                                <button
                                                   onClick={() => {
                                                      setSelectedQuestions(
                                                         selectedQuestions.filter(
                                                            (it) => {
                                                               return (
                                                                  i.id !== it.id
                                                               );
                                                            }
                                                         )
                                                      );
                                                   }}
                                                   className={styles.delete}
                                                ></button>
                                             ) : (
                                                <button
                                                   onClick={() => {
                                                      setSelectedQuestions(
                                                         (prev) => {
                                                            return [
                                                               ...prev,
                                                               i,
                                                            ];
                                                         }
                                                      );
                                                   }}
                                                   className={styles.add}
                                                ></button>
                                             )}
                                          </td>
                                       </tr>
                                    );
                                 })}
                           </table>
                        )}
                        <div className={styles.pagination_btn}>
                           <Pagination
                              total={questData.length}
                              // pageSizeOptions={null}
                              hideOnSinglePage={true}
                              showSizeChanger={false}
                              onChange={(e) => {
                                 setListState(e * 10);
                              }}
                           />
                        </div>
                     </div>
                  </div>

                  {error &&
                     leveStatus === 2 &&
                     Number(selectedQuestions.length) != Number(levelData.totalQuestions) && (
                        <p
                           style={{
                              color: "red",
                              fontWeight: "700",
                              margin: "25px 0",
                           }}
                        >
                           Select {levelData.totalQuestions} question
                        </p>
                     )}
                  <div
                     className={styles.btn_container}
                     style={{ width: "50%", marginTop: "20px" }}
                  >
                     <button
                        onClick={() => {
                           steLevelStatus(1);
                        }}
                     >
                        Back
                     </button>

                     <button
                        onClick={() => {
                           if (selectedQuestions.length !== Number(levelData.totalQuestions)) {
                              setError(`Select ${levelData.totalQuestions}  question`);
                           } else {
                              setError("");
                              steLevelStatus(3);
                           }
                        }}
                     // disabled={selectedQuestions.length===0}
                     >
                        Save & Proceed
                     </button>
                  </div>
               </div>
            )}
            {leveStatus === 3 && (
               <div className={styles.side_data}>
                  <Styled.LevelWrapDiv>
                     {addLevels.map((level, levelIndex) => {
                        let numStyle = {};
                        let textStyle = {};
                        if (level.status === 2) {
                           numStyle = {
                              color: "#1B49EA",
                              backgroundColor: "#EDF0FD",
                              fontWeight: "bold",
                           };
                           textStyle = { fontWeight: "bold" };
                        } else if (level.status === 3) {
                           numStyle = {
                              color: "#21C17A",
                              backgroundColor: "#cbf5e3",
                              fontWeight: "bold",
                           };
                           textStyle = { color: "#21C17A" };
                        }
                        return (
                           <Styled.LevelDiv key={`testing_${levelIndex}`}>
                              <Styled.LevelNumDiv style={numStyle}>
                                 {levelIndex + 1}
                              </Styled.LevelNumDiv>
                              <div style={textStyle}>{level.name}</div>
                           </Styled.LevelDiv>
                        );
                     })}
                     <Styled.LevelActiveBarDiv style={{ width: "305px" }} />
                     <Styled.LevelBarDiv practice={true} />
                  </Styled.LevelWrapDiv>

                  {/* <div className={styles.question_count_container}>
                  <div className={styles.question_count}>
                     Question in Test : <strong>0/3</strong>
                  </div>
                  <div className={styles.question_count}>
                     Total Marks : <strong>0/3</strong>
                  </div>
               </div> */}
                  <div
                     style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "80%",
                     }}
                  >
                     <div style={{ display: "flex", flexDirection: "column" }}>
                        <p style={{ marginBottom: "15px", fontWeight: "700" }}>
                           Start Date
                        </p>
                        <DatePicker
                           style={{ width: "270px", height: "42px" }}
                           onChange={(e) => handleDate(e, "start")}
                        />
                     </div>
                     <div style={{ display: "flex", flexDirection: "column" }}>
                        <p style={{ marginBottom: "15px", fontWeight: "700" }}>
                           End date
                        </p>
                        <DatePicker
                           style={{ width: "270px", height: "42px" }}
                           onChange={(e) => handleDate(e, "end")}
                        />
                     </div>
                  </div>
                  <div className={styles.radio_btn}>
                     <div>
                        <input
                           type="radio"
                           id="public"
                           name="status"
                           value="PUBLIC"
                           checked={access === "PUBLIC"}
                           onChange={(e) => {
                              setAccess(e.target.value);
                           }}
                        />
                        <label for="public">public</label>
                     </div>
                     <br />
                     <div>
                        <input
                           type="radio"
                           id="private"
                           name="status"
                           value="PRIVATE"
                           checked={access === "PRIVATE"}
                           onChange={(e) => {
                              setAccess(e.target.value);
                           }}
                        />
                        <label for="private">private</label>
                     </div>
                  </div>
                  {access === "PRIVATE" && (
                     <div>
                        <p>Email Address</p>
                        <textarea
                           style={{
                              width: "50%",
                              height: "100px",
                              padding: "15px",
                           }}
                           placeholder="Enter email address "
                           onChange={(e) => {
                              setEmails(e.target.value.split(","));
                           }}
                           value={emails.join()}
                        />
                        {!validEmailCheck && leveStatus === 3 && (
                           <p
                              style={{
                                 color: "red",
                                 fontWeight: "700",
                                 margin: "25px 0",
                              }}
                           >
                              Please enter valid email
                           </p>
                        )}
                     </div>
                  )}
                  {error && leveStatus === 3 && (
                     <p
                        style={{
                           color: "red",
                           fontWeight: "700",
                           margin: "25px 0",
                        }}
                     >
                        {error}
                     </p>
                  )}
                  <div
                     className={styles.btn_container}
                     style={{ width: "50%", marginTop: "30px" }}
                  >
                     <button
                        onClick={() => {
                           steLevelStatus(2);
                        }}
                     >
                        Back
                     </button>
                     <button
                        onClick={() => {
                           if (access === "PRIVATE" || access === "PUBLIC") {
                              publishLevel();
                              setError("");
                           } else {
                              setError(
                                 "Please select the status of question (i.e. private or public)"
                              );
                           }
                        }}
                     >
                        Publish
                     </button>
                  </div>
               </div>
            )}
         </div>
      </div>
   );
};

export default PracticeModule;
